import React, { Component } from 'react';
import Checkbox from 'Components/Checkbox';

const SALES_ORG_TYPE_MAP = {
    SO: ["FIND"],
    STO: ["FIST"],
    BOTH: ["FIND", "FIST"],
};

const getSalesOrgTypeKey = (arr) => {
    if (!arr || arr.length === 0) return null;
    if (arr.includes("FIND") && arr.includes("FIST")) return "BOTH";
    if (arr.includes("FIND")) return "SO";
    if (arr.includes("FIST")) return "STO";
    return null;
};

class Tk11Details extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tk11Type: props.rfqDetails.tk11_type || "901",
            salesOrgType: getSalesOrgTypeKey(props.rfqDetails.sales_organisation_type) || ["FIND"],
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.rfqDetails.tk11_type !== this.props.rfqDetails.tk11_type) {
            this.setState({ tk11Type: this.props.rfqDetails.tk11_type || "901" });
        }
        if (prevProps.rfqDetails.sales_organisation_type !== this.props.rfqDetails.sales_organisation_type) {
            this.setState({ salesOrgType: getSalesOrgTypeKey(this.props.rfqDetails.sales_organisation_type) });
        }
    }

    setTk11Type = (type, typeName) => {
        const { viewMode, rfqDetails, onChange } = this.props;
        if (viewMode) {
            return;
        }
        this.setState({ tk11Type: type });
        if (rfqDetails.setTk11Type) {
            rfqDetails.setTk11Type(type, typeName);
        }
        if (onChange) {
            onChange();
        }
    }

    setSalesOrgType = (key) => {
        const { viewMode, rfqDetails, onChange } = this.props;
        if (viewMode) return;
        this.setState({ salesOrgType: key });
        if (rfqDetails.setSalesOrgType) {
            rfqDetails.setSalesOrgType(SALES_ORG_TYPE_MAP[key]);
        }
        if (onChange) {
            onChange();
        }
    }

    render() {
        const { viewMode} = this.props;
        const { tk11Type, salesOrgType } = this.state;
        return (
            <div className="box-shadow ph-20 pv-20 br-5">
                <div className="fBold fs-22 border-bottom-light lh-40p mb-30">
                    Tk11 Details <sup className="danger-color ml-2 pr t-4">*</sup>
                </div>

                <div className="fBold fs-18 mb-10 header-medium-color">
                    Select Configuration Type
                </div>
                <div className="flex flex-column">
                    <Checkbox
                        label="901 – Sales Organisation / Shipment Route / Service Agent"
                        checked={tk11Type === "901"}
                        className="mb-20"
                        onCheck={() => this.setTk11Type("901", "Sales Organisation / Shipment Route / Service Agent")}
                        disabled={viewMode}
                    />
                    <Checkbox
                        label="902 – Sales Organisation / Shipment Route / Trans. Grp."
                        checked={tk11Type === "902"}
                        className="mb-20"
                        onCheck={() => this.setTk11Type("902", "Sales Organisation / Shipment Route / Trans. Grp.")}
                        disabled={viewMode}
                    />
                    <Checkbox
                        label="903 – Sales Organisation / Shipment Route"
                        checked={tk11Type === "903"}
                        onCheck={() => this.setTk11Type("903", "Sales Organisation / Shipment Route")}
                        disabled={viewMode}
                    />
                </div>

                <div className="fBold fs-18 mb-10 mt-20 header-medium-color">
                    Select Sales Organisation Type 
                </div>
                <div className="flex flex-column">
                    <Checkbox
                        label="SO (FIND)"
                        checked={salesOrgType === "SO"}
                        className="mb-20"
                        onCheck={() => this.setSalesOrgType("SO")}
                        disabled={viewMode}
                    />
                    <Checkbox
                        label="STO (FIST)"
                        checked={salesOrgType === "STO"}
                        className="mb-20"
                        onCheck={() => this.setSalesOrgType("STO")}
                        disabled={viewMode}
                    />
                    <Checkbox
                        label="Both - SO/STO (FIND&FIST)"
                        checked={salesOrgType === "BOTH"}
                        onCheck={() => this.setSalesOrgType("BOTH")}
                        disabled={viewMode}
                    />
                </div>
            </div>
        );
    }
}

export default Tk11Details;
